[
    {
        "display": "true",
        "ui_columnname": "reportDate",
        "db_columnname": "reportDate",
        "datatype": "String",
        "mappingkey": "reportDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "rsmsStatus",
        "db_columnname": "rsmsStatus",
        "datatype": "String",
        "mappingkey": "rsmsStatus",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "groupName",
        "db_columnname": "groupName",
        "datatype": "String",
        "mappingkey": "groupName",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "errorCodeList",
        "db_columnname": "errorCodeList",
        "datatype": "String",
        "mappingkey": "errorCodeList",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "createDate",
        "db_columnname": "createDate",
        "datatype": "String",
        "mappingkey": "createDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "updateDate",
        "db_columnname": "updateDate",
        "datatype": "String",
        "mappingkey": "updateDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "lastUpdatedBy",
        "db_columnname": "lastUpdatedBy",
        "datatype": "String",
        "mappingkey": "lastUpdatedBy",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
    "display": "true",
    "ui_columnname": "actionType",
    "db_columnname": "actionType",
    "datatype": "String",
    "mappingkey": "actionType",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "errorROEID",
    "db_columnname": "errorROEID",
    "datatype": "String",
    "mappingkey": "errorROEID",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "firmROEID",
    "db_columnname": "firmROEID",
    "datatype": "String",
    "mappingkey": "firmROEID",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "type",
    "db_columnname": "type",
    "datatype": "String",
    "mappingkey": "type",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "CATReporterIMID",
    "db_columnname": "CATReporterIMID",
    "datatype": "String",
    "mappingkey": "CATReporterIMID",
    "dropdown": "NO",
    "disabled": "true",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "fillKeyDate",
    "db_columnname": "fillKeyDate",
    "datatype": "String",
    "mappingkey": "fillKeyDate",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "fulfillmentID",
    "db_columnname": "fulfillmentID",
    "datatype": "String",
    "mappingkey": "fulfillmentID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "optionID",
    "db_columnname": "optionID",
    "datatype": "String",
    "mappingkey": "optionID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "priorFillKeyDate",
    "db_columnname": "priorFillKeyDate",
    "datatype": "String",
    "mappingkey": "priorFillKeyDate",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "priorFulfillmentID",
    "db_columnname": "priorFulfillmentID",
    "datatype": "String",
    "mappingkey": "priorFulfillmentID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "originatingIMID",
    "db_columnname": "originatingIMID",
    "datatype": "String",
    "mappingkey": "originatingIMID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "eventTimestamp",
    "db_columnname": "eventTimestamp",
    "datatype": "String",
    "mappingkey": "eventTimestamp",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "manualFlag",
    "db_columnname": "manualFlag",
    "datatype": "Boolean",
    "mappingkey": "manualFlag",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "electronicTimestamp",
    "db_columnname": "electronicTimestamp",
    "datatype": "String",
    "mappingkey": "electronicTimestamp",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "fulfillmentLinkType",
    "db_columnname": "fulfillmentLinkType",
    "datatype": "String",
    "mappingkey": "fulfillmentLinkType",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "quantity",
    "db_columnname": "quantity",
    "datatype": "Float",
    "mappingkey": "quantity",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "price",
    "db_columnname": "price",
    "datatype": "Float",
    "mappingkey": "price",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "clientDetails",
    "db_columnname": "clientDetails",
    "datatype": "String",
    "mappingkey": "clientDetails",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}, {
    "display": "true",
    "ui_columnname": "firmDetails",
    "db_columnname": "firmDetails",
    "datatype": "String",
    "mappingkey": "firmDetails",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
}]